const getWeekLabel = (index) => {
  if (index === 0) {
    return "This Week";
  }

  if (index === 1) {
    return "Next Week";
  }

  return "Later";
};

const ShiftSelection = ({ scheduledHours, index, dolStatus }) => {
  const weekLabel = getWeekLabel(index);
  const total = dolStatus === "Full-Time" ? 40 : 20;
  const remainingHours = (total - scheduledHours).toFixed(1);

  return (
    <div className="flex w-full items-center gap-2 px-1">
      <span className="shrink-0 whitespace-nowrap text-[18px] font-bold leading-[1.2] text-gray-900">
        {weekLabel}
      </span>

      <span className="shrink-0 text-[26px] font-bold leading-[2] text-gray-900">
        |
      </span>

      <div className="flex items-center gap-[18px] whitespace-nowrap rounded-[2px] bg-gray-100 px-[10px] py-[1px]">
        <span className="text-[14px] font-normal leading-[1.5] text-gray-900">
          Scheduled: {scheduledHours}
        </span>
        <span className="text-[14px] font-normal leading-[1.5] text-gray-900">
          Remaining: {remainingHours}
        </span>
      </div>
    </div>
  );
};

export { ShiftSelection };
